<template>
  <v-app :dark="darkMode" class="override-light-theme" :key="appKey">
    <template v-if="internet">
      <mq-layout mq="mobile" class="h-100">
        <v-app-bar
          v-if="showTopBar && loggedIn"
          flat
          app
          class=""
        >
          <v-avatar @click="$router.push({name:'Home'})">
            <v-img src="./assets/weSupport.png" alt="We"></v-img>
          </v-avatar>
          <v-toolbar-title style="line-height: 1" class="ml-3">
            <!-- {{ headerText ? headerText : bottomNavItems[bottomNav].title }} -->
            <!-- headerText simple string or valid html -->
            <p class="ma-0" v-html="headerText"></p>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <ThemeSwitch v-if="$route.name == 'Member'" @changeTheme="(theme)=>{
              darkMode = theme
            }"/>
          <!-- <v-btn icon @click="history">
            <v-badge small color="transparent" overlap>
              <v-icon>mdi-36px mdi-chevron-left</v-icon>
            </v-badge>
          </v-btn> -->
          <v-btn icon @click="notificationsDrawer = !notificationsDrawer">
            <v-badge
              color="green"
              overlap
              :content="notifList.length"
              :value="notifList.length"
            >
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn>
          <v-btn icon @click="openSwitchUser">
            <v-avatar size="36">
              <img v-if="userModel.storedUrl" :src="siteName + userModel.storedUrl">
              <v-icon v-else>mdi-account</v-icon>
            </v-avatar>
          </v-btn>
          <!-- <v-btn icon @click="openSettings">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
        </v-app-bar>
        <template v-if="internet && !iosInstallHelper">
          <v-main v-if="userType == 2 && loggedIn">
            <v-container style="height:100%;overflow: auto;" class="py-0">
            <transition name="router-anim">
              <router-view
                @changeHeader="changeHeader"
                @showSnackBar="showSnackBar"
                @resetSnackBar="resetSnackBar"
                @setBottomNav="setBottomNav"
                @loadingChange="loadingChange"
                @userTypeChange="userTypeChange"
              />
              <!-- </keep-alive> -->
            </transition>
          </v-container>
          </v-main>
          <v-main v-else>
            <v-container>
            <transition name="router-anim">
              <router-view
                @changeHeader="changeHeader"
                @showSnackBar="showSnackBar"
                @resetSnackBar="resetSnackBar"
                @setBottomNav="setBottomNav"
                @loadingChange="loadingChange"
                @userTypeChange="userTypeChange"
              />
            </transition>
          </v-container>
          </v-main>
          <v-footer app class="pa-0" v-if="loggedIn && !$route.name.includes('Payment')">
            <BottomNavigation  class="w-100" @openBtm="bottomSheet = true"/>
          </v-footer>
        </template>
        <!-- <v-bottom-navigation
          v-if="loggedIn"
          color="primary"
          slider-color="primary"
          grow
          app
          v-model="selected"
          background-color="primary"
        >
          <v-btn class="spansize" @click="openUi('/')" >
            <v-icon class="mdi-36px">mdi-home</v-icon>
          </v-btn>
          <v-btn class="spansize" @click="openUi('history')">
            <v-icon>mdi-credit-card-multiple</v-icon>
          </v-btn>
          <v-btn class="spansize" @click="openUi('cardDetails')">
            <v-icon>mdi-history</v-icon>
          </v-btn>
          <v-btn class="spansize" @click="bottomSheet = true">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </v-bottom-navigation> -->
      </mq-layout>
      <mq-layout mq="tablet">
        <div class="divStyle">
          <v-img
            src="./assets/undraw_sync_re_492g.svg"
            :aspect-ratio="3.9"
            contain
          />
          <v-row>
            <v-card-title primary-title class="cardTitle justify-center">
              <div>You Can Only Access Through Mobile Or Tablet</div>
            </v-card-title>
          </v-row>
        </div>
      </mq-layout>
    </template>
    <template v-else>
      <div
        v-if="!internet"
        style="background: #121212 !important"
        class="h-100"
      >
        <v-row
          class="center-the-content"
          style="background: #121212 !important"
        >
          <img
            src="./assets/no-internet.gif"
            style="object-fit: none !important; padding-top: 100px !important"
          />
        </v-row>
        <v-row>
          <v-card-title
            primary-title
            class="cardTitle justify-center"
            style="background: #121212 !important"
          >
            <div>You're Offline</div>
          </v-card-title>
        </v-row>
      </div>
    </template>

    <v-snackbar v-model="snackBar" :timeout="snackTimeout" :color="snackColor">
      <!-- style="height: 0px;" -->
      <div v-show="false" class="v-menu__content--active" />
      <!-- This prevents dialogs closing when snackbar is clicked -->
      {{ snackText }}
      <v-btn v-if="showCloseBtn" color="white" icon @click="snackBar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- bottom sheet -->
    <v-bottom-sheet v-model="bottomSheet">
      <v-sheet class="text-center" height="300px">
        <v-list class="pt-0 pb-0">
          <v-subheader>Account</v-subheader>
          <v-list-item>
            <v-avatar size="32px" tile>
              <v-icon>mdi-account orange--text</v-icon>
            </v-avatar>
            <v-list-item-title class="t-a-l pl-4">{{
              this.userModel.name
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-avatar size="32px" tile>
              <v-icon>mdi-phone orange--text</v-icon>
            </v-avatar>
            <v-list-item-title class="t-a-l pl-4">{{
              this.userModel.mobileNumber
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list class="pt-0 pb-0">
          <v-subheader>Settings</v-subheader>
        </v-list>
        <v-list class="pt-0 pb-0">
          <v-list-item>
            <ThemeSwitch @changeTheme="(theme)=>{
              darkMode = theme
            }"/>
          </v-list-item>
          <v-list-item
            @click="profileMenuClicked('execute,this.logoutFromMenu()')"
          >
            <v-avatar size="32px" tile>
              <v-icon>mdi-logout orange--text</v-icon>
            </v-avatar>
            <v-list-item-title class="t-a-l pl-4">Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-bottom-sheet>
    <!-- notifications -->
    <v-navigation-drawer
      v-model="notificationsDrawer"
      fixed
      app
      right
      temporary
      width="100%"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="d-flex">
            <v-icon
              class="mdi mdi-chevron-right"
              @click="notificationsDrawer = false"
              style="font-size: 1.9em"
            />
            <span style="font-size: 1.5em" @click="notificationsDrawer = false"
              >Notifications</span
            >
            <v-spacer />
            <v-icon
              ripple
              class="mdi mdi-notification-clear-all"
              @click="readNotifications()"
            />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list>
        <v-list-item v-for="(item, index) in notifList" :key="index" link>
          <!-- <v-list-item-icon>
            <v-icon
              class="mdi mdi-check success--text"
            ></v-icon> </v-list-item-icon> -->
          <v-list-item-content>
            <!-- <v-card
                  class="mx-auto rounded-xl"
                  elevation="24"
                  @click="Show(item)"
                  max-width="100%"
                >
                  {{ item.message }}
                </v-card> -->
            <v-list-item-title class="text-wrap">
              {{ item.message }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- notifications -->
<!-- {{ "Hai",importantNotifications }} -->
    <common v-if="loggedIn" ref="common" />
    <dploader v-if="loading" />
    <SwitchUser :userModel="userModel" ref="switchUserRef" v-if="loggedIn"  @loadingChange="loadingChange" @changedUser="getUserDetails"/>
    <v-dialog v-model="dialogIsOpen" v-if="dialogIsOpen&&importantNotifications">
      <v-card class="rounded-xl" elevation="5">
        <v-card-title>
          <span>Important Notification</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>
              <h4>{{importantNotifications.message }}</h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
            <v-btn  small elevation="0" @click="readImportantNotification()" dark color="success">Ok</v-btn> 
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      </v-dialog>
  </v-app>
</template>

<script>
import Vue from "vue";
import VueMq from "vue-mq";
import { mapState } from "vuex";
import common from "@/components/tools/common";
import {
  removeToken,
  getUserType,
  removetUserType,
  removeStockPoint,
  removeLocation,
  removeLoginType,
} from "@/utils/auth";
import dploader from "@/components/tools/toolbox/loader";
import { callApi } from "@/api/others";
import { getToken } from "@/utils/auth";
import BottomNavigation from "@/components/navigation/BottomNavigation.vue";
import ThemeSwitch from "@/components/tools/ThemeSwitch.vue";
import SwitchUser from "@/components/wesupport/settings/SwitchUser.vue"
import { returnURL } from "@/api/login.js";
Vue.use(VueMq, {
  breakpoints: {
    mobile: 2025,
    tablet: 4200,
  },
});
export default {
  components: { dploader, common, BottomNavigation, ThemeSwitch, SwitchUser },
  name: "App",
  data() {
    return {
      dialogIsOpen:false,
      refKeyDialoge:0,
      // importantNotifications:{message:""},
      importantNotifications:null,
      imageExistsFlag: false,
      loggedIn: false,
      selected: null,
      ticketModel: {},
      userModel: {},
      darkMode: true,
      internet: true,
      showTopBar: true,
      showBottomNav: false,
      loading: false,
      isLogout: false,
      logedOut: false,
      isLoading: false,
      menuDrawer: false,
      notificationsDrawer: false,
      notifList: [],
      ticketHdr: [],
      headerText: "",
      snackBar: false,
      snackTimeout: 3000,
      snackColor: "dark",
      snackText: "",
      showCloseBtn: true,
      bottomNav: 0,
      userType: 0,
      bottomNavItems: [
        {
          title: "Home",
          icon: "mdi-home",
          action: "route,/",
        },
      ],
      bottomSheet: false,
      profileMenu: [
        {
          subheader: "Profile",
          title: "Account",
          icon: "mdi-account secondary--text",
          action: "route,/",
        },
      ],
      // timer: "",
      openedUI: "/",
      iosInstallHelper: false,
      siteName:returnURL(),
      appKey:0
    };
  },
  computed: mapState({
    loggedOut: (state) => state.user.loggedOut,
    topBarShow: (state) => state.user.topBarShow,
    bottomNavShow: (state) => state.user.bottomNavShow,
    snackbarText: (state) => state.user.snackbarText,
    path: function() {
      return this.$route.path;
    },
  }),
  watch: {
    '$route.name'(){
       var tk = getToken();
       if(tk){
        this.getNotifications()
        this.getImportantNotifications();
       }
    },
    darkMode(nv) {
      this.$vuetify.theme.dark = nv;
      localStorage.setItem("dark", nv);
    },
    loggedOut: function(newValue, oldValue) {
      if (this.logedOut == true) {
        this.logOut();
      }
    },
    topBarShow(nv, ov) {
      // if (this.topBarShow == true) {
      this.showTopBar = this.topBarShow;
      // }
    },
    bottomNavShow(nv, ov) {
      this.showBottomNav = this.bottomNavShow;
    },
    snackbarText(newValue, oldValue) {
      this.showSnackBar(
        this.snackbarText.text,
        this.snackbarText.color,
        3000,
        false
      );
    },
    isLogout(nv, ov) {
      if (!nv) {
        this.$store.commit("SET_TOPBARSHOW", true);
        this.$store.commit("SET_BOTTOMNAVSHOW", true);
        document.getElementById("app").classList.add("override-light-theme");
      } else {
        this.$store.commit("SET_TOPBARSHOW", false);
        this.$store.commit("SET_BOTTOMNAVSHOW", false);
        document.getElementById("app").classList.remove("override-light-theme");
      }
    },
    snackBar(nv) {
      if (!nv) {
        this.resetSnackBar();
      }
    },
    openedUI: function(newv, oldv) {
      if (newv !== oldv && newv !== undefined && newv !== null) {
        if (!this.$route.path.includes(newv) || newv === "/") {
          this.$router.push(newv);
          this.openUi(newv);
        }
      }
    },
    // bottomSheet(nv){
    //   if(!nv){
    // }
    // }
  },
  created() {
    var t = localStorage.getItem(btoa("Admin-Token"));
    if (!t) {
      removeToken("Admin-Token");
      this.showTopBar = false;
      this.showBottomNav = false;
      this.loggedOut = true;
    } else {
      this.showTopBar = true;
      this.showBottomNav = true;
    }
  },
  mounted() {
   
    // console.log(this.$url);
    // //console.log(window.navigator.userAgentData);
    // const ua = navigator.userAgent;
    // const device = {
    //   iPad: /iPad/.test(ua),
    //   iPhone: /iPhone/.test(ua),
    //   Android4: /Android 4/.test(ua),
    // };
    // if (device.iPhone) {
    //   if (!window.matchMedia("(display-mode: standalone)").matches) {
    //     this.iosInstallHelper = true;
    //   }
    // }
    // // if (window.matchMedia("(display-mode: standalone)").matches) {
    // //   alert("display-mode is app installed");
    // // } else {
    // //   alert("display-mode is browser");
    // // }
    this.checkLogin();
    if (this.$route.path != "/") {
      this.$router.push("/");
    }
    // this.getUserDetails();
    let d = localStorage.getItem("dark");
    if (d == "true") {
      this.darkMode = true;
      this.$vuetify.theme.dark = this.darkMode;
    } else {
      if (d == undefined || d == null) {
        // this.setDarkMode();
        this.$vuetify.theme.dark = false;
      } else {
        this.darkMode = false;
        this.$vuetify.theme.dark = this.darkMode;
      }
    }
    this.userTypeChange();
    if (this.userType != null) {
      this.getNotifications();
      //this.timer = setInterval(this.getNotifications, 15000);
    }
    if (this.$route.params.referenceId != undefined)
      this.menuRId = this.$route.params.referenceId.toString();
    // online and offline listener
    var self = this;
    window.addEventListener("online", function(e) {
      self.showSnackBar("You are back online!", "success", 3000, false);
      self.internet = true;
    });

    window.addEventListener("offline", function(e) {
      self.showSnackBar("You are offline!", "dark", 3000, false);
      self.internet = false;
    });
    // this event fires when user comes back to this app after minimising
    // window.addEventListener('visibilitychange', function(e) {
    //   self.showSnackBar("Welcome back!", "dark", 7000,false)
    // }, false);
    // this.getImportantNotifications();
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  },
  methods: {
    readImportantNotification() {
      var self = this;
      var common = self.$refs.common;
      var url = "/api/wesupport/Notification/ReadImportantNotification";
      var data={ id:self.importantNotifications.id} ;
      callApi(url, "post", data)
        .then((response) => {
          self.dialogIsOpen=false;
          self.refKeyDialoge++;
          self.getImportantNotifications();
          self.getNotifications();
          // self.notifList = response.data.data;
          // this.importantNotifications = {};
        })
        .catch((error) => {
          console.log(error);
          common.ManageResponse(error.response);
          // this.importantNotifications = {};
        });
    },
    async checkLogin() {
      var tk = getToken();
      if (tk) {
        await this.getUserDetails();
        // this.GetOrganizationInfo();
        // this.$store
        //   .dispatch("GetUserInfo")
        //   .then((response) => {
        //     //  location.reload()
        //     this.userName = this.$store.getters.name;
        //     // this.userId = this.$store.getters.userId;
        //     // this.userEmail = this.$store.getters.email;
        //     this.userDefaultBranch();
        //     this.GetBranches();
        //   })
        //   .catch(() => {
        //     //  this.logOut();
        //     // this.$router.push("/");
        //     //  this.loading = false;
        //   });
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
        this.logOut();
        // removeBioMetric();
      }
    },
    closeIosInstallHelper() {
      this.iosInstallHelper = false;
    },
    readNotifications() {
      var self = this;
      var common = self.$refs.common;
      var url = "/api/wesupport/Notification/MarkAllAsRead";
      callApi(url, "post", this.notifList)
        .then((response) => {
          // self.notifList = response.data.data;
          this.notifList = [];
        })
        .catch((error) => {
          console.log(error);
          common.ManageResponse(error.response);
          this.notifList = [];
        });
    },
    openUi(value) {
      this.openedUI = value;
    },
    cancelAutoUpdate() {
      // clearInterval(this.timer);
    },
    history() {
      this.$router.go(-1);
    },
    setDarkMode() {
      this.darkMode = true;
      this.$vuetify.theme.dark = this.darkMode;
      localStorage.setItem("dark", true);
    },
    logOut() {
      this.$store.commit("SET_TOPBARSHOW", false);
      this.$store.commit("SET_BOTTOMNAVSHOW", false);
      setTimeout(() => {
        this.isLogout = true;
      }, 200);
      this.$store.commit("SET_TOKEN", "");
      removeToken("Admin-Token");
      removetUserType();
      removeStockPoint();
      removeLocation();
      removeLoginType();
      this.$router.push("/login").catch((err) => {});
    },
    changeHeader(h) {
      this.headerText = h;
    },
    showSnackBar(text, color, timeout, closebtn) {
      if (text) {
        if (color) {
          this.snackColor = color;
        }
        if (timeout) {
          this.snackTimeout = timeout;
        }
        if (closebtn == false) {
          this.showCloseBtn = false;
        }
        this.snackText = text;
        this.snackBar = true;
      }
    },
    resetSnackBar() {
      // this.snackBar=false
      this.snackText = "";
      this.snackColor = "primary";
      this.snackTimeout = 3000;
    },
    changeRouteto(r) {
      if (r.includes("route,")) {
        this.$router.push(r.split(",")[1]).catch((err) => {});
      } else if (r.includes("execute,")) {
        eval(r.split(",")[1]);
      }
    },
    logoutFromMenu() {
      this.$store.commit("SET_TOKEN", "");
      removeToken("Admin-Token");
      removetUserType();
      location.reload();
    },
    setBottomNav(v) {
      this.bottomNav = v;
    },
    loadingChange(v) {
      this.loading = v;
    },
    profileMenuClicked(i) {
      if (i.includes("route,")) {
        this.bottomSheet = false;
        this.$router.push(i.split(",")[1]).catch((err) => {});
      } else if (i.includes("execute,")) {
        this.bottomSheet = false;
        eval(i.split(",")[1]);
      }
    },
    updateBottomNamItems() {
      this.bottomNavItems = [];
      if (this.userType == 1) {
        var membermenu = [
          {
            title: "Home",
            icon: "mdi-home",
            action: "route,/",
          },
          {
            title: "Ledger View",
            icon: "mdi-scale-balance",
            action: "route,/ledgerView",
          },
          {
            title: "Members",
            icon: "mdi-account-box-multiple",
            action: "route,/memberDirectory",
          },
          {
            title: "Parcel Order",
            icon: "mdi-cart",
            action: "route,/deliverFood",
          },
          {
            title: "Order & Dine",
            icon: "mdi-cart",
            action: "route,/orderFood",
          },
        ];
        this.bottomNavItems = this.bottomNavItems.concat(membermenu);
      } else if (this.userType == 2) {
        var wiaterMenu = [
          {
            title: "Home",
            icon: "mdi-home",
            action: "route,/",
          },
        ];
        this.bottomNavItems = this.bottomNavItems.concat(wiaterMenu);
      }
      // this.bottomNavItems.push({
      //   title: "Profile",
      //   icon: "mdi-account",
      //   action: "execute,this.bottomSheet=true",
      // });
    },
    userTypeChange() {
      this.userType = getUserType();
      if (!this.userType || this.userType == 0) {
        this.logOut();
      } else {
        this.getNotifications();
       // this.timer = setInterval(this.getNotifications, 15000);
        this.updateBottomNamItems();
      }
    },
    getNotifications() {
      var self = this;
      //var common = self.$root.$children[0].$refs.common
      var common = self.$refs.common;
      var url = "/api/wesupport/Notification/MemberNotifications";
      callApi(url, "get", "")
        .then((response) => {
          // console.log("🚀 ~ .then ~ response:", response)
          self.notifList = response.data.data;
          // console.log("🚀 ~ .then ~ self.notifList:", self.notifList)
          // if (self.notifList.length > 0) {
          //   Notification.warning({
          //     title: 'We Support',
          //     message: self.notifList.length + ' New Notifications',
          //     position: 'bottom-right',
          //     duration: 4000
          //   })
          // }
        })
        .catch((error) => {
          console.log("ERROR : ");
          console.log(error);
          common.ManageResponse(error.response);
        });
    },
    getImportantNotifications() {
      var self = this;
      var common = self.$refs.common;
      var url = "/api/wesupport/Notification/MemberImportantNotifications";
      callApi(url, "get", "")
        .then((response) => {
          if(response.data != null ) 
          {
            self.importantNotifications = response.data.data;
            self.dialogIsOpen=true;
            self.refKeyDialoge++;
          }
          else {
            self.importantNotifications = {message:""};
            self.dialogIsOpen=false;
            self.refKeyDialoge++;
          }
        })
        .catch((error) => {
          console.log("ERROR : ");
          console.log(error);
          common.ManageResponse(error.response);
        });
    },
    getUserDetails(updateAppKey = false) {
      return new Promise((resolve)=>{
        var self = this;
      var common = self.$refs.common;
      self.userType = getUserType();
      // if (self.userType == 2) {
      //   var url = "/api/wesupport/WaiterMaster/getbymobilenumber";
      //   callApi(url, "post", "")
      //     .then((response) => {
      //       self.userModel = response.data.data;

      //       // console.log(this.userModel);
      //     })
      //     .catch((error) => {
      //       common.ManageResponse(error.response);
      //     });
      // } else
      if (self.userType == 2) {
        this.loadingChange(true);
        var url1 = `/api/wesupport/Member/getMemIdByMobNumber?memberId=${this.decryptMemId()}`;
        callApi(url1, "get", "")
          .then((response) => {
            self.userModel = response.data.data;
            this.$store.commit("SET_NAME", self.userModel.name)
              if(updateAppKey){
                this.appKey++;
              }
            
            // this.encryptMemId(self.userModel.id);
            
            
            
            // this.encryptIt(self.userModel.id,btoa("memberId"),19);
            resolve(true)
          })
          .catch((error) => {
            //console.log("Error :" + error);
            common.ManageResponse(error.response);
            resolve(true)
          })
          .finally(()=>{
            this.loadingChange(false);
          })
          ;       
      }
      })
      
    },
    Show(item) {
      if (this.userType == 2) this.viewDetails(item);
    },
    viewDetails(item) {
      var self = this;
      // var common = self.$root.$children[0].$refs.common
      var common = self.$refs.common;
      var url = "/api/wesupport/KitchenDisplay/GetTicketId";
      var data = {
        id: item.referenceId,
      };
      callApi(url, "post", data)
        .then((response) => {
          self.ticketHdr = response.data.data;
          this.LoadDisplay(self.ticketHdr[0].headerId);
        })
        .catch((error) => {
          common.ManageResponse(error.response);
        });
    },
    LoadDisplay(header) {
      if (header) {
        this.dploader = true;
        this.notificationsDrawer = false;
         {
          this.ticketModel.id = header;
          this.$events.fire("showdetails", this.ticketModel);
        }
      }
    },
    openSwitchUser(){
      this.$refs.switchUserRef.open();
    }
  },
};
</script>
<style lang="scss">
.router-anim-enter-active {
  animation: coming 0.3s;
  animation-delay: 0.4s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 0.3s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-10px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(10px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

// override theme light
.override-light-theme.theme--light {
  background: #f9f9f9 !important;
}

.box-shadow-secondary {
  box-shadow: 0px 2px 4px -1px rgba(17, 73, 127, 0.24),
    0px 4px 5px 0px rgba(17, 73, 127, 0.26) !important;
}

.carousel-3d-slide {
  background-color: #fbfbfb !important;
}

.center-the-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.t-a-c {
  text-align: center;
}

.t-a-l {
  text-align: left;
}

.t-a-r {
  text-align: right;
}

.w-100 {
  width: 100% !important;
}

ul.multiselect__content {
  padding-left: 0 !important;
}

.multiselect__option--highlight {
  background: var(--secondary-color) !important;
}

.multiselect__option--highlight:after {
  background: var(--secondary-color) !important;
}

.custom-ms .multiselect__tags {
  // height: 3.1em !important;
  font-size: 1.1em !important;
  padding-left: 0;
}

.custom-ms .multiselect__select {
  top: 9px !important;
}

.custom-ms .multiselect__input {
  top: 5px !important;
}

.custom-ms .multiselect__single {
  margin-top: 7px !important;
  padding-left: 0;
}

.multiselect__tags {
  border-top-color: #fff0 !important;
  border-left-color: #fff0 !important;
  border-right-color: #fff0 !important;
  border-bottom-color: #9e9e9e !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.multiselect__placeholder {
  color: #666666 !important;
}

.bold-text {
  font-weight: bold !important;
}

.no-tbl-footer .v-data-footer {
  display: none !important;
}

// hide table header in mobile browsers
.v-data-table-header-mobile {
  display: none;
}

.h-auto {
  height: auto !important;
}

.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.fw-700 {
  font-weight: 700;
}

.fw-800 {
  font-weight: 800;
}

.fg-1 {
  flex-grow: 1;
}

.fg-2 {
  flex-grow: 2;
}

.fg-3 {
  flex-grow: 3;
}

.fg-4 {
  flex-grow: 4;
}

.dpnotificationbadge {
  background-color: #d57a16 !important;
  height: 0.6em !important;
  width: 0.6em !important;
  border-radius: 0.5em !important;
}

.cardTitle {
  border-style: dashed;
  border-width: 0px;
  width: 100%;
  border-color: #888;
}
</style>
<style lang="css">
@import "/css/dpstyles.css";

.spansize {
  font-size: 0.75rem;
}
</style>
<style>
@import "/css/styleModules/dpAnimations.css";
.divStyle {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
}
</style>
<style>
.v-btn::before {
  content: "";
  z-index: -1;
  width: 4.2em;
  height: 4.2em;
  border-radius: 50%;
  position: absolute;
  transform: scale(0);
  transition: background-color var(--duration), transform var(--duration);
}
</style>
